import { MY_FUNDS_URL, HELP_CENTER_URL } from "@stadium/constants/routes";

import {
  MY_PURACHES_URL,
  STADIUM_LOCKER_DASHBOARD_URL,
  KITS_DASHBOARD_ROUTE,
  MYSHOPS_URL,
  CAMPAIGNS_URL,
  MERGED_ACCOUNT_SETTINGS_URL,
  MERGED_ACCOUNT_CONTACTS_URL,
  MERGED_WALLET_URL,
  P2P_LANDING_PAGE_URL,
  DASHBOARD_ROUTE,
  getStadiumRouteWithWorkspaceSlug,
  eshops,
  settings,
} from "../../constants/routes";
import { MY_WALLET } from "@stadium/constants/wallets";

import { getMyPointsWalletRoute } from "@stadium/helpers/routes";

export const getStadiumFundsLinks = ({ trackEvent }) => [
  {
    label: MY_WALLET,
    to: MERGED_WALLET_URL,
    onLinkClick: () => trackEvent({ target: "stadium-wallet" }),
  },
  {
    label: "My Funds",
    to: MY_FUNDS_URL,
    onLinkClick: () => trackEvent({ target: "spend-and-redeem" }),
  },
];

export const STADIUM_CONTACTS_LINKS_LABEL = {
  contancts: "Contacts",
};

export const getStadiumContactLinks = ({ trackEvent }) => [
  {
    label: STADIUM_CONTACTS_LINKS_LABEL.contancts,
    to: MERGED_ACCOUNT_CONTACTS_URL,
    onLinkClick: () => trackEvent({ target: "contacts" }),
  },
];

export const getProfileDropdownQuickLinks = ({ trackEvent }) => [
  {
    label: "My Swag",
    to: STADIUM_LOCKER_DASHBOARD_URL,
    onLinkClick: () => trackEvent({ target: "my-swag" }),
  },
  {
    label: "My Shops",
    to: MYSHOPS_URL,
    onLinkClick: () => trackEvent({ target: "shops" }),
  },
  {
    label: "My Campaigns",
    to: CAMPAIGNS_URL,
    onLinkClick: () => trackEvent({ target: "my-campaigns" }),
  },
  {
    label: "My Recognition Programs",
    to: P2P_LANDING_PAGE_URL,
    onLinkClick: () => trackEvent({ target: "recognition" }),
  },
];

export const getStadiumFeaturesLinks = ({ trackEvent }) => [
  {
    label: "Shops",
    to: MYSHOPS_URL,
    onLinkClick: () => trackEvent({ target: "shops" }),
  },
  {
    label: "Kits & Send Items",
    to: KITS_DASHBOARD_ROUTE,
    onLinkClick: () => trackEvent({ target: "kits" }),
  },
  {
    label: "Help Center",
    to: HELP_CENTER_URL,
    onLinkClick: () => trackEvent({ target: "help-center" }),
  },
];

export const getMinifiedAccountLinks = ({ trackEvent, workspaceWalletFlagEnabled }) => [
  {
    label: "My Home",
    to: DASHBOARD_ROUTE,
    onLinkClick: () => trackEvent({ target: "my-home" }),
  },
  {
    label: "My Orders",
    to: MY_PURACHES_URL,
    onLinkClick: () => trackEvent({ target: "my-orders" }),
  },
  {
    label: "My Funds",
    to: getMyPointsWalletRoute(workspaceWalletFlagEnabled),
    onLinkClick: () => trackEvent({ target: "spend-and-redeem" }),
  },
  {
    label: "Account Settings",
    to: MERGED_ACCOUNT_SETTINGS_URL,
    onLinkClick: () => trackEvent({ target: "account-settings" }),
  },
  {
    label: "Help Center",
    to: HELP_CENTER_URL,
    onLinkClick: () => trackEvent({ target: "help-center" }),
  },
];

const getNavLinks = ({ trackEvent }) => [
  {
    label: "Stadium Home",
    to: DASHBOARD_ROUTE,
    onLinkClick: () => trackEvent({ target: "my-home" }),
  },
  {
    label: "My Orders",
    to: MY_PURACHES_URL,
    onLinkClick: () => trackEvent({ target: "my-orders" }),
  },
  {
    label: "Stadium Wallet",
    to: MERGED_WALLET_URL,
    onLinkClick: () => trackEvent({ target: "stadium-wallet" }),
  },
  {
    label: STADIUM_CONTACTS_LINKS_LABEL.contancts,
    to: MERGED_ACCOUNT_CONTACTS_URL,
    onLinkClick: () => trackEvent({ target: "contacts" }),
  },
  {
    label: "Account Settings",
    to: MERGED_ACCOUNT_SETTINGS_URL,
    onLinkClick: () => trackEvent({ target: "account-settings" }),
  },
];

export const getProfileData = ({ trackEvent }) => [{ items: getNavLinks({ trackEvent }) }];

export const getMiniAccountDropdownData = ({ trackEvent, workspaceWalletFlagEnabled }) => [
  {
    title: "MY ACCOUNT",
    items: getMinifiedAccountLinks({ trackEvent, workspaceWalletFlagEnabled }),
  },
];

export const getNavAccountDropdownData = ({
  trackEvent,
  isStore,
  showHeaderNavLinks,
  accessibilityEnabled,
  workspaceSlug,
  workspaceSidebarFlagEnabled,
  workspaceContactsEnabled,
  canViewShops,
  isMobileDevice,
}) => {
  const items = [];
  const workspaceLogicEnabled = workspaceSlug && workspaceSidebarFlagEnabled;

  if (isStore || showHeaderNavLinks) {
    items.push({
      label: "Home",
      to: workspaceLogicEnabled
        ? getStadiumRouteWithWorkspaceSlug({ workspaceSlug, pathname: eshops.dashboard })
        : DASHBOARD_ROUTE,
      onLinkClick: () => trackEvent({ target: "my-home" }),
    });

    if (canViewShops) {
      items.push({
        label: "My Shops",
        to: workspaceLogicEnabled
          ? getStadiumRouteWithWorkspaceSlug({
              workspaceSlug,
              pathname: `${eshops.base}${eshops.live}`,
            })
          : MYSHOPS_URL,
        onLinkClick: () => trackEvent({ target: "shops" }),
      });
    }
  } else if (!workspaceContactsEnabled) {
    items.push({
      label: STADIUM_CONTACTS_LINKS_LABEL.contancts,
      to: workspaceLogicEnabled
        ? getStadiumRouteWithWorkspaceSlug({ workspaceSlug, pathname: settings.contacts })
        : MERGED_ACCOUNT_CONTACTS_URL,
      onLinkClick: () => trackEvent({ target: "contacts" }),
    });
  }

  items.push({
    label: "Account Settings",
    to: workspaceLogicEnabled
      ? getStadiumRouteWithWorkspaceSlug({ workspaceSlug, pathname: settings.home })
      : MERGED_ACCOUNT_SETTINGS_URL,
    onLinkClick: () => trackEvent({ target: "account-settings" }),
  });

  if (isMobileDevice) {
    items.push({
      label: "Chat With Us",
      to: "",
      onLinkClick: (e) => {
        e.preventDefault();
        window?.zE?.("messenger", "open");
      },
    });
  }

  if (accessibilityEnabled) {
    items.push({
      label: "Accessibility Support",
      to: "",
      onLinkClick: (e) => e.preventDefault(),
      otherProps: { "data-acsb-custom-trigger": true },
    });
  }

  return [{ items }];
};

export const getResponsiveNavDropdownData = () => [
  {
    label: "Home",
    to: DASHBOARD_ROUTE,
  },
  {
    label: "Account Settings",
    to: MERGED_ACCOUNT_SETTINGS_URL,
  },
];
